import debounce from 'lodash/debounce';
import React, { useMemo } from 'react';
import { useHeaderContext } from '@/creditflowresearch/application/Header/HeaderContext';
import { SEARCH_DEBOUNCE } from '@/creditflowresearch/application/SearchHeaderMenu/constants';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import SearchInput from './SearchInput';

const MemoizedSearchInput = React.memo(SearchInput);

const SearchInputContainer = () => {
  const { searchText, searchTextChanged, search } = useHeaderContext();

  const onChange = useMemo(() => {
    const searchDebounced = debounce(
      (productsList: IProduct[], regionsList: IRegion[]) => search(productsList, regionsList),
      SEARCH_DEBOUNCE,
    );

    return (e: React.ChangeEvent<HTMLInputElement>, productsList: IProduct[], regionsList: IRegion[]) => {
      searchTextChanged(e.target.value);
      if (e.target?.value?.trim()) {
        searchDebounced(productsList, regionsList);
      }
    };
  }, [searchTextChanged, search]);

  return <MemoizedSearchInput value={ searchText } onChange={ onChange } />;
};

export default SearchInputContainer;
